/*
 * @Author: Fan
 * @Date: 2020-04-16 19:34:28
 * @description:
 * @LastEditors: Fan
 */
import { DataType } from "../../../typings";
import { styleControlOptions } from ".";
import i18n from "../../../i18n";
export const editableControlOptions = {
    $id: "editableControlOptions",
    type: DataType.Object,
    $ref: styleControlOptions.$id,
    properties: {
        displayFormula: {
            type: DataType.String,
            title: i18n.t('dataitem.DisplayConditions').toString(),
        },
        onChange: {
            type: DataType.String,
            title: i18n.t('dataitem.ChangeEvent').toString(),
        },
    },
};
